import React from 'react';

/* ------------------------------------------------------------------
   LABEL 첫 화면 한 줄 소개

   홍보 링크로 처음 들어온 사람이 "여기가 뭐 하는 곳인지" 3초 안에
   알게 하는 장치. 스티키 헤더 바로 아래에 붙고, 스크롤하면 같이 올라간다.

   문구만 바꾸려면 아래 TITLE / SUB 두 줄만 수정하면 된다.
   기존 .lb-* 디자인(부티크 편집샵)의 타이포 스케일에 맞춰놨으므로
   폰트 크기·색을 임의로 키우면 헤더와 어긋난다.
------------------------------------------------------------------ */

const TITLE = '동대문 도매택을 한눈에!';   // LABEL_HERO_COPY
const SUB = '모든스토어의 신상을 매일 업데이트';   // LABEL_HERO_COPY

const wrap = {
  padding: '14px 20px 16px',
  textAlign: 'center',
  borderBottom: '1px solid #f4f4f4',
};

const titleStyle = {
  margin: 0,
  fontSize: '13.5px',
  fontWeight: 600,
  lineHeight: 1.45,
  letterSpacing: '0.01em',
  color: '#111',
};

const subStyle = {
  margin: '5px 0 0',
  fontSize: '11.5px',
  fontWeight: 400,
  lineHeight: 1.45,
  letterSpacing: '0.02em',
  color: '#999',
};

export default function Hero() {
  return (
    <div style={wrap}>
      <h1 style={titleStyle}>{TITLE}</h1>
      <p style={subStyle}>{SUB}</p>
    </div>
  );
}
